import { BaseOptionModel } from '../../model';

export const HasTrialSmileAddOnOptions = Object.freeze<BaseOptionModel<boolean>[]>([
    { value: true, label: '有 Trial Smile' },
    { value: false, label: '无 Trial Smile' },
]);
